import React from 'react'
import PropTypes from 'prop-types'
import './styles.css'
import Icon from 'components/icons'
import cn from 'classnames'
import colors from '../../styles/colors.css'

function VideoControls(props) {
  const {
    micOn,
    camOn,
    phoneOn,
    toggleMic,
    toggleCam,
    hangUp,
    hideHangUpButton
  } = props
  return (
    <div styleName={cn('videoMenu', {hiddenHangUp: hideHangUpButton})}>
      <div styleName='videoMenuButtonContainer'>
        <button
          styleName={cn('menuBtn', 'micBtn', 'no-touch', {micOff: !micOn})}
          onClick={toggleMic}
          aria-label={`${micOn ? 'Unmuted' : 'Muted'}`}
        >
          {micOn ? <Icon name='mic-on' fill={colors.shade0} /> : <Icon name='mic-off' fill={colors.shade5} /> }
        </button>
        <button
          styleName={cn('menuBtn', 'videoBtn', 'no-touch', {camOff: !camOn})}
          onClick={toggleCam}
          aria-label={`Camera ${camOn ? 'On' : 'Off'}`}
        >
          {camOn ? <Icon name='cam-on' fill={colors.shade0} /> : <Icon name='cam-off' fill={colors.shade5} /> }
        </button>
        { !hideHangUpButton && (
          <button
            styleName={cn('menuBtn', 'phoneBtn', 'no-touch', {phoneOn: phoneOn, phoneOff: !phoneOn})}
            onClick={hangUp}
            aria-label={'Hang Up'}
          >
            {phoneOn ? <Icon name='hang-up' fill={colors.primary4c}/> : <Icon name='hang-up' fill={colors.shade0}/>}
          </button>
        )}
      </div>
    </div>
  )
}

VideoControls.propTypes = {
  micOn: PropTypes.bool.isRequired,
  camOn: PropTypes.bool.isRequired,
  phoneOn: PropTypes.bool,
  toggleMic: PropTypes.func.isRequired,
  toggleCam: PropTypes.func.isRequired,
  hangUp: PropTypes.func.isRequired
}

export default VideoControls
